
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"color",attrs:{"d":"M12.345.805a.5.5 0 00-.845.362V4.3a.7.7 0 01-.7.7H.7a.7.7 0 00-.7.7v8.6a.7.7 0 00.7.7h10.1a.7.7 0 01.7.7v3.133a.5.5 0 00.845.362l9.275-8.833a.5.5 0 000-.724L12.345.805z","fill":"#A3A3A3"}})])
          )
        }
      }
    